<div class="row mb-3">
	<label class="col-form-label text-end" [ngClass]="labelClass" [for]="id">
		<ng-container *ngIf="label">
			<span [innerHTML]="label"></span>
		</ng-container>

		<ng-container *ngIf="!label">
			<ng-content></ng-content>
		</ng-container>
	</label>

	<div class="align-self-center" [ngClass]="inputClass">
		<input type="text" #input="ngModel"
			   class="form-control text-mask text-end"
			   currencyMask
			   [options]="{ prefix: '', thousands: formatThousands ? ',' : '', precision: 0 }"
			   [id]="id"
			   [name]="name"
			   [(ngModel)]="value"
			   (ngModelChange)="onValueChange($event)"
			   [placeholder]="placeholder"
			   [required]="required"
			   [readonly]="readonly"
			   [disabled]="disabled"
			   [min]="min"
			   [max]="max"
			   [class.is-invalid]="!isValid"
			   autocomplete="off" />

		<div *ngIf="hint" class="form-text text-muted" [innerHTML]="hint"></div>
	</div>
</div>
